import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'FunctionToPass/AllByLanguage', method: 'GET', body: null, token: token })
}
